import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import routes from "../routes";

const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: routes.signIn,
  authenticatedSelector: state => (state.auth.token ? true : false),
  wrapperDisplayName: "UserIsAuthenticated"
});

const locationHelper = locationHelperBuilder({});
const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || routes.offers,
  allowRedirectBack: false,
  authenticatedSelector: state => (state.auth.token ? false : true),
  wrapperDisplayName: "UserIsNotAuthenticated"
});

export { userIsNotAuthenticated, userIsAuthenticated };



// WEBPACK FOOTER //
// ./src/auth/utils.js